import { render, staticRenderFns } from "./ListForms.vue?vue&type=template&id=f0ac2248&"
import script from "./ListForms.vue?vue&type=script&lang=js&"
export * from "./ListForms.vue?vue&type=script&lang=js&"
import style0 from "./ListForms.vue?vue&type=style&index=0&id=f0ac2248&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports